'use client';

import { Flex, For, Link, Heading, Box } from "@chakra-ui/react";
import ShadowBox from "@/components/partials/ShadowBox";
import { LuEqualNot } from "react-icons/lu"

export default function RelatedNews({ posts, label = 'Leia também' }) {
  return (
    <>
      { posts && posts.length > 0 ? (
        <ShadowBox padding="8">
          <Heading as="h4" fontFamily="inherit" fontWeight="700" fontSize="2em" pb="4" ineHeight="1" color="blue.500">
            { label }
          </Heading>

          <Flex flexWrap="wrap">
            <For each={posts} >
              {(item, index) => (
                <Flex
                  key={index}
                  pb="4"
                  borderColor="blue.500"
                  borderLeftWidth="4px"
                  flex="48%"
                  my="4"
                  mx="2"
                  h="180px"
                  justifyContent="center"
                  flexDirection="column"
                  _hover={{ bgColor: "gray.50"  }}
                  transition="all 0.2s ease"
                >
                  <Link
                    href={item.postPermalink}
                    title={ item.postTitle }
                    pl="4"
                    pb="1"
                    fontSize="1.4em"
                  >
                    { item.postTitle }
                  </Link>

                  <Link
                    href={item.postPermalink}
                    title={ item.postTitle }
                    pl="4"
                    fontSize="0.9em"
                  >
                    { item.postSubTitle }
                  </Link>
                </Flex>
              )}
            </For>
          </Flex>
        </ShadowBox>
      ) : (
        <Box minH="600px">
          <ShadowBox>
            <Flex py="20" flexDirection="column" alignItems="center">
            <Box fontSize="7em" color="blue.500">
              <LuEqualNot margin="auto" />
            </Box>

            <Box pt="8" textAlign="center">
              <Box fontSize="2em" fontWeight="300" mb="4">
                Nenhuma notícia encontrada.
              </Box>

              <Box>
                <Link href="/" title="Voltar à Página Inicial" _hover={{ textDecoration: 'underline'}}>Clique aqui</Link> para voltar à página inicial.
              </Box>
            </Box>
            </Flex>
          </ShadowBox>
        </Box>
      )}
    </>
  )
}
